import React, { useState, useCallback, useEffect } from 'react';
import { MathComponent } from 'mathjax-react';
import Button from 'react-bootstrap/Button';
import getCurrentTime from 'utils';
import { ASSESSMENTS } from 'config/constants';

function OSpanMathFlashcard({
  problem = null,
  solution = null,
  isCorrect = false,
  trial = null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  recordResult = () => {},
  displayResult = false,
}) {
  if (problem) {
    const delay = ASSESSMENTS.MATH_FLASH_INTERVAL;
    setTimeout(recordResult, delay);
  }
  const [startTime] = useState(getCurrentTime);
  const [answered, setAnswered] = useState(false);
  const [answer, setAnswer] = useState({});
  const [buttons, setButtons] = useState(false);

  const submitResults = useCallback(
    (response) => {
      recordResult({
        startTs: startTime,
        endTs: getCurrentTime(),
        result: response,
        trial,
      });
    },
    [recordResult, startTime, trial]
  );

  const handleAnswer = useCallback(
    (response) => {
      setAnswered(true);
      setAnswer({
        value: response,
        time: getCurrentTime(),
      });
      if (displayResult) {
        setTimeout(() => {
          submitResults(response);
        }, ASSESSMENTS.DISPLAY_RESULTS_INTERVAL);
      } else {
        submitResults(response);
      }
    },
    [displayResult, submitResults]
  );

  useEffect(() => {
    if (solution) {
      setTimeout(() => {
        setButtons(true);
      }, 100);
    }
  });

  return (
    <div className="d-flex flex-column justify-content-center h-100" style={{ marginTop: '100px' }}>
      <div style={{ fontSize: '400%' }}>
        <MathComponent tex={problem || solution} />
      </div>
      {buttons && !answered && (
        <div className="d-flex justify-content-center my-3">
          <Button
            className="btn-assessment-primary mx-1"
            onClick={() => {
              setAnswered(true);
              handleAnswer(true);
            }}
          >
            True
          </Button>
          <Button
            className="btn-assessment-primary mx-1"
            onClick={() => {
              setAnswered(true);
              handleAnswer(false);
            }}
          >
            False
          </Button>
        </div>
      )}
      {answered && displayResult && (
        <div>
          <div className="d-flex justify-content-center mb-4">
            {`Your answer is ${answer.value === isCorrect ? 'correct' : 'incorrect'}`}
          </div>
        </div>
      )}
    </div>
  );
}

export default OSpanMathFlashcard;
